import { Link, NavLink, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import "../styles/CommonHeader.css";
import { auth, db } from "../Firebase";
import { doc, getDoc } from "firebase/firestore";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { useCartWishlist } from "../Context/CartWishlistContext";

const CommonHeader = () => {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);
  const [photo, setPhoto] = useState("");
  //const [cartCount, setCartCount] = useState(0);
  //const [wishlistCount, setWishlistCount] = useState(0);
  const [open, setOpen] = useState(false);

  const { cartCount, wishlistCount } = useCartWishlist();

  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  /* ================= AUTH ================= */
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);

      if (!currentUser) {
        setPhoto("");
        setRole(null);
        return;
      }

      const snap = await getDoc(doc(db, "users", currentUser.uid));
      if (snap.exists()) {
        const data = snap.data();
        setPhoto(data.profileImage || currentUser.photoURL || "");
        setRole(data.role || null);
      }
    });

    return () => unsubscribe();
  }, []);

  
  /* ================= CLOSE DROPDOWN ================= */
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  /* ================= LOGOUT ================= */
  const handleLogout = async () => {
    await signOut(auth);
    setOpen(false);
    navigate("/login");
  };

  const handleMyCoursesClick = () => {
    role === "teacher"
      ? navigate("/teacherCourse")
      : navigate("/mycourse");
  };

  return (
    <header className="common-header">
      <Link to="/" className="logo">Vidify</Link>

      <div className="header-search">
        <input type="text" placeholder="Search for anything" />
      </div>

      {/* ===== NAV LINKS ===== */}
      <nav className="nav-links">
        <NavLink
          to={role === "teacher" ? "/teacherCourse" : "/mycourse"}
          className={({ isActive }) =>
            isActive ? "active-link" : ""
          }
        >
          My Courses
        </NavLink>

        <NavLink
          to="/courses"
          className={({ isActive }) =>
            isActive ? "active-link" : ""
          }
        >
          Courses
        </NavLink>
      </nav>


      <div className="header-icons" ref={dropdownRef}>
        {role !== "teacher" && (
          <>
            <Link to="/wishlist" className="wishlist-icon-wrapper">
              <img src="/assets/images/headericon/wishlist.png" />
              {wishlistCount > 0 && (
                <span className="wishlist-badge">
                  {wishlistCount}
                </span>
              )}
            </Link>

            <Link to="/cart" className="cart-icon-wrapper">
              <img src="/assets/images/headericon/cart.png" />
              {cartCount > 0 && (
                <span className="cart-badge">
                  {cartCount}
                </span>
              )}
            </Link>
          </>
        )}

        {!user && (
          <>
            <Link to="/login">Login</Link>
            <Link to="/signup">Sign Up</Link>
          </>
        )}

        {user && (
          <div className="profile-dropdown">
            <img
              src={photo || "/assets/images/default-avatar.png"}
              className="profile-img"
              onClick={() => setOpen(!open)}
            />

            {open && (
              <div className="dropdown-menu">
                <Link to="/profile">My Profile</Link>
                <button onClick={handleLogout}>
                  Logout
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default CommonHeader;
